<template>
	<div class="footer">
		<div class="r1">
			<!--<p class="p1">智慧防疫参观服务系统</p>
			<p class="p2">Museum of Heilongjiang Province</p>-->
			<ul>
				<li>
					友情链接：
				</li>
				<li>
					<a href="https://www.sjtu.edu.cn/">上海交通大学</a>
				</li>
				<li>
					<a href="http://www.qianxslib.sjtu.edu.cn/">钱学森图书馆</a>
				</li>
				<li>
					<a href="https://archives.sjtu.edu.cn/">档案文博管理中心</a>
				</li>
			</ul>
		</div>
		<a href="http://www.beian.miit.gov.cn/" class="info">备案号：沪交ICP备20200073</a>
	</div>
</template>

<script>
export default {
	name: 'myfooter',
	data () {
	    return {
	    }
	},
	created () {
		let vm = this;
	},
	mounted () {
		let vm = this;
	},
	methods: {
	}
}
</script>

<style scoped lang="scss">
@import "@/style/theme.scss";
.footer{
	width: 100%;
	height: 140px;
	padding-top: 45px;
	position: absolute;
	bottom: 0px;
	/*background: url(../../../static/img/bottom_bg.png) center top / 100% 100% #750C00;*/
	background: $base-color;
	a:hover{
		text-decoration: underline;
	}
	.r1{
		width: 100%;
		height: auto;
		margin: 0 auto;
		text-align:center;
		p{
			color: #fff;
			text-align: center;
			white-space: nowrap;
			display:inline-block;
			&.p1{
				border-bottom: 1px solid #fff;
				font-size: 26px;
				line-height: 150%;
				letter-spacing: 2px;
			}
			&.p2{
				font-size: 12px;
				line-height: 150%;
			}
		}
		ul{
			overflow: hidden;
			font-size: 12px;
			display: inline-block;
			li{
				float: left;
				padding: 0 10px;
				border-right: 1px solid #fff;
				color: #fff;
				&:first-child{
					border: 0;
					padding: 0;
				}
				&:last-child{
					border: 0;
				}
				a{
					color: #fff;
				}
			}
		}
	}
	.info{
		display: block;
		margin-top: 15px;
		font-size: 14px;
		line-height: 150%;
		color: #fff;
		text-align: center;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/common/footer.vue